'use client';
/**
 * `useImpersonation` — public hook for the engineer impersonation subsystem
 * (spec 048). Web platform.
 *
 * Reads live state from the `ImpersonationStateContext` (injected by
 * `SdkImpersonationProvider`). Actions (activate / stop / resolveTarget)
 * are exposed as stable callbacks via the `ImpersonationActionsContext`.
 *
 * Components and the dev toolkit use this hook only — no direct store
 * imports in UI code.
 *
 * Relocated from `frontend/src/lib/impersonation/use-impersonation.ts` as
 * part of the auth cutover (spec 009, FILE 14, Group F).
 */
import { createContext, useContext } from 'react';
const DEFAULT_IMPERSONATION = {
    isActive: false,
    target: null,
    network: null,
    grantToken: null,
    expiresAt: null,
    activate: async () => { },
    stop: async () => { },
    resolveTarget: async () => null,
};
export const ImpersonationContext = createContext(DEFAULT_IMPERSONATION);
/**
 * Returns the live impersonation state and actions.
 * Mount `<SdkImpersonationProvider>` above this call site.
 */
export function useImpersonation() {
    return useContext(ImpersonationContext);
}
//# sourceMappingURL=use-impersonation.js.map